import { z } from 'zod';

import { zodJSPlainDate } from '../dates/BrandedDate';
import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateDepositEvent = BaseLoanEvent.extend({
  type: z.literal('createDeposit'),
  deposit: Payment,
  comment: z.string().optional(),
  isInterestOnEscrow: z.boolean().optional(),
  startOfNextAccrualPeriod: zodJSPlainDate.optional(),
}).superRefine((event, ctx) => {
  if (!event.isInterestOnEscrow && event.startOfNextAccrualPeriod != null) {
    ctx.addIssue({
      code: 'custom',
      message: 'startOfNextAccrualPeriod must not be set when isInterestOnEscrow is false',
      path: ['startOfNextAccrualPeriod'],
    });
  }
});
export type CreateDepositEvent = z.infer<typeof CreateDepositEvent>;
